export default "__VITE_ASSET__DsJX1tm9__"